import type { MouseEvent, ReactNode } from 'react';
import { Link } from '@ksyos/router';
import { Icon, IconColor, InlineElement } from '../../common';
import styles from './IconLink.module.css';

interface IIconLinkProps {
    icon: string;
    iconPostion: 'left' | 'right';
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    text?: ReactNode;
    to: string | (() => string);
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function IconLink(props: IIconLinkProps) {
    let className = styles.iconLink;

    if (props.iconPostion) {
        className += props.iconPostion === 'left' ? ` ${styles.hasIconLeft}` : ` ${styles.hasIconRight}`;
    }

    const to = typeof props.to === 'string' ? props.to : props.to();

    return (
        <Link
            className={className}
            onClick={props.onClick}
            to={to}
        >
            <Icon
                className={styles.icon}
                color={IconColor.secondary}
                icon={props.icon}
            />
            <InlineElement className={styles.span}>{props.text}</InlineElement>
        </Link>
    );
}
